import BaseApi from "@api/base.api";
import Http from "@services/http.js";

export default class SearchJobApi extends BaseApi {
    static get entity() {
        return "search/job";
    }

    static async getUserMatchedKeywords(params = {}) {
        return await Http.get("search/user-matched-keywords", params);
    }

    static async search(params = {}) {
        return await Http.post("search", params);
    }
}
